import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

const formatDate = dateString => {
  if (!dateString) return '';
  return moment(dateString).format('MMM D, YYYY');
};

const ComparisonHistoryItem = ({ comparison, onToggleBookmark, onClick }) => {
  const { t } = useTranslation();

  const productNames = comparison.products.map(product => product.name).join(' vs ');
  const createdAt = formatDate(comparison.createdAt);

  const handleToggleBookmark = event => {
    event.stopPropagation();
    onToggleBookmark(comparison.id);
  };

  return (
    <div className='comparison-history-item' role='button' tabIndex={0} onClick={onClick}>
      <button
        type='button'
        className={`bookmark-button ${comparison.isBookmarked ? 'bookmarked' : ''}`}
        onClick={handleToggleBookmark}
        aria-label={t('ai_compare.bookmark')}
      >
        {comparison.isBookmarked ? '★' : '☆'}
      </button>
      <div className='comparison-content'>
        <div className='comparison-title'>{productNames}</div>
        <div className='comparison-meta'>
          <span className='comparison-verdict'>{comparison.verdict}</span>
          <span className='comparison-count'>
            {comparison.products.length} {t('ai_compare.products_label')}
          </span>
        </div>
      </div>
      <div className='comparison-date'>{createdAt}</div>
    </div>
  );
};

ComparisonHistoryItem.propTypes = {
  comparison: PropTypes.shape({
    id: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({ name: PropTypes.string.isRequired })).isRequired,
    verdict: PropTypes.string,
    createdAt: PropTypes.string,
    isBookmarked: PropTypes.bool,
  }).isRequired,
  onToggleBookmark: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default ComparisonHistoryItem;
